<template>
  <v-container>
    <v-layout>
    <v-flex>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    </v-layout>
       <h3 class="primary--text">Reporte de usuarios</h3>
        <download-excel
          :data   = "getReportUser">
          <v-btn small color="primary">Descargar Datos</v-btn>
        </download-excel>
      <v-data-table id="containerGen"
        :headers="headers"
        :items="$store.state.usersReport"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.login }}</td>
          <td class="text-xs-left">{{ props.item.firstName }}</td>
          <td class="text-xs-left">{{ props.item.lastName }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ props.item.activated?"Activo":"Inactivo" }}</td>
          <td class="text-xs-left">{{ props.item.authorities }}</td>
          <td class="text-xs-left">{{ props.item.establishments }}</td>
          <td class="text-xs-left">{{ props.item.createdDate }}</td>
          <td class="text-xs-left">{{ props.item.auditEventDate }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
  import User from "../../model/User";
  import Catalog from "../../model/Catalog";
  export default {

    data () {
      return {
        search: '',
        valid: false,
        date: '',
        menu: false,
        documentValidation: "",
        documentRules: [],
        codeRules: [
          v => !!v || 'El código es requerido',
          v => (v && v.length <= 50) || 'El código debe tener menos de 50 caracteres'
        ],
        emailRules: [
          v => !!v || 'El email es requerido',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
        ],
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        headers: [
          { text: 'Id', value: 'id' },
          { text: 'Código de usuario', value: 'code' },
          { text: 'Nombres', value: 'name' },
          { text: 'Apellidos', value: 'apellido' },
          { text: 'Email', value: 'email' },
          { text: 'Estado', value: 'estado' },
          { text: 'Roles', value: 'roles' },
          { text: 'Establecimientos', value: 'est' },
          { text: 'Fecha de Creación', value: 'fecha' },
          { text: 'Fecha de Última Conexión', value: 'fecha' }
        ],
        editedIndex: -1,
        user: new User(),
        userRols:[],
        userEstablisments:[],
        catalog: new Catalog()
      };
    },methods:{

    },
      computed : {
      getReportUser(){
        var reportList=[]
        var report = this.$store.state.usersReport
        for(var i=0; i<report.length; i++){
          var reportUser= new Object()
          reportUser.ID=report[i].id
          reportUser.USUARIO=report[i].login
          reportUser.NOMBRES=report[i].firstName
          reportUser.APELLIDOS=report[i].lastName
          reportUser.EMAIL=report[i].email
          reportUser.ESTADO=report[i].activated?"ACTIVO":"INACTIVO"
          reportUser.ROLES=report[i].authorities
          reportUser.NUMERO_DOCUMENTO=report[i].document
          reportUser.CELULAR=report[i].cellphone
          reportUser.FECHA_NACIMIENTO=report[i].birthday
          reportUser.TIPO_DE_DOCUMENTO=report[i].documentType
          reportUser.ESTABLECIMIENTO=report[i].establishments
          reportUser.FECHA_CREACION=report[i].createdDate
          reportUser.FECHA_ULTIMA_CONEXION=report[i].auditEventDate==null?"":report[i].auditEventDate
          reportList.push(reportUser)
        }
        return reportList
      }
      },
      beforeCreate(){
      this.catalog = new Catalog()
        this.$store.dispatch('getRols').then(response => {
        })
        this.$store.dispatch('getUsersReport').then(response => {
        })
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/UserReport.vue